import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=8ac3c0cc&scoped=true"
import script from "./selectGoods.vue?vue&type=script&lang=js"
export * from "./selectGoods.vue?vue&type=script&lang=js"
import style0 from "./selectGoods.vue?vue&type=style&index=0&id=8ac3c0cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac3c0cc",
  null
  
)

export default component.exports